import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = { data: null, ts: 0 };
let inflight = null;

const hasLive = (data) => data && (data.games || []).some((g) => g.status === 'LIVE');

export const fetchScores = async () => {
  const ttl = hasLive(cache.data) ? 25000 : 120000;
  if (cache.data && Date.now() - cache.ts < ttl) return cache.data;
  if (inflight) return inflight;
  inflight = axios
    .get(`${API}/v2/scores`)
    .then((r) => {
      cache = { data: r.data, ts: Date.now() };
      inflight = null;
      return r.data;
    })
    .catch(() => {
      inflight = null;
      if (cache.data) return { ...cache.data, stale: true };
      return { available: false, stale: false, games: [], teams: {}, updated_at: null };
    });
  return inflight;
};

export const etDay = (dateStr) =>
  new Date(dateStr).toLocaleDateString('en-US', { timeZone: 'America/New_York' });

export const formatGameTime = (dateStr) => {
  const d = new Date(dateStr);
  const today = etDay(new Date().toISOString());
  const day = etDay(dateStr);
  const time = d.toLocaleTimeString('en-US', {
    timeZone: 'America/New_York',
    hour: 'numeric',
    minute: '2-digit',
  });
  if (day === today) return `Today ${time}`;
  const date = d.toLocaleDateString('en-US', {
    timeZone: 'America/New_York',
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
  return `${date} · ${time}`;
};
